<template>
  <div>
    <tableComponent
      ref="tableComponent"
      :tableSettings="tableSettings"
      :tableData="tableData"
      :headers="headers"
      :enable-row-clickable="true"
      @newDocument="newDocument"
      @clickedRow="openCategory($event)"
      @reloadData="reloadDataFunc"
    />
  </div>
</template>

<script>
import { getUniqueId } from "../../components/api/api";
import tableComponent from "../../components/_utils/dataTableHelpers/tableComponent.vue";

export default {
  components: { tableComponent },
  data: () => ({
    tableSettings: {
      title: "",
      showSelect: false,
      showHeaderToolbar: true,
      headerButtons: [
        {
          title: "inspections.category.new",
          color: "secondary",
          action: "newDocument",
          structure: true,
          icon: "add",
          iconDark: true,
          dark: true,
          outlined: true,
        },
      ],
    },
    counts: {},
  }),
  async created() {
    this.fetchCounts();
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("inspections.category.tableHeader.name"),
          value: "name",
          align: "left",
        },
        {
          text: this.$t("folderCount.total"),
          value: "folderTotal",
          align: "center",
          sortable: false,
        },
        {
          text: "",
          value: "inspectionCategoryAction",
          align: "right",
          sortable: false,
        },
      ];
    },
    tableData() {
      return {
        tableComponentSlots: [
          {
            id: getUniqueId(),
            slotName: "item.folderTotal",
            componentName: "folderCount",
            config: { kind: "total", counts: this.counts },
          },
          {
            id: getUniqueId(),
            slotName: "item.inspectionCategoryAction",
            componentName: "inspectionCategoryAction",
          },
        ],
        itemKey: "id",
        uriPartPrepend: "inspectionCategory",
        uriPartAppend: "",
        populate: [],
        sort: "-createdAt",
        editFormPushName: "inspectionCategoryForm",
      };
    },
  },
  methods: {
    reloadDataFunc() {
      this.$refs.tableComponent.getData();
      this.fetchCounts();
    },
    async fetchCounts() {
      this.counts =
        (await this.$store.dispatch("getInspectionCategoryCounts")) || {};
    },
    newDocument() {
      this.$router.push({
        name: "inspectionCategoryForm",
        params: { id: "1", mode: "new" },
      });
    },
    openCategory(event) {
      this.$router.push({
        name: "inspections",
        params: {
          inspectionCategoryId: event.id,
          inspectionCategoryName: event.name,
        },
      });
    },
  },
};
</script>
